import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { LocalStorageAdapter } from '@/lib/adapters/local-storage';
import { getInitialState } from '@/lib/utils/local-state';

export const adapter = new LocalStorageAdapter('config');

export type SetValueAction = PayloadAction<{
  key: keyof AppConfigState;
  value: any;
}>;

// Define a type for the slice state
type AppConfigState = typeof defaultInitialState;

// Define the initial state using that type
const defaultInitialState = {
  darkMode: false,
  version: 1,
  locale: 'en-GB',
};

export const appConfigSlice = createSlice({
  name: 'appConfig',

  initialState: getInitialState(adapter, defaultInitialState),

  reducers: {
    setValue(state, action: SetValueAction) {
      const { key, value } = action.payload;
      // @ts-ignore
      state[key] = value;
    },

    reset(state: AppConfigState) {
      return { ...defaultInitialState };
    },
  },
});

export const { setValue } = appConfigSlice.actions;

export default appConfigSlice.reducer;
